module.exports = __webpack_public_path__ + "static/media/CheckCircleIcon.ccf553e1.svg";